import Service from "./abstract/Service";

export default class AppService extends Service {

  findReleaseNumber() {
    return this.get(config.app.api_url + `/info/release`);
  }
}
